import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { RotateCw } from "lucide-react";
import { adminApi } from "../api";
import { EmptyState, Panel } from "../components/DataTable";

export function OrdersPage() {
  const client = useQueryClient();
  const query = useQuery({ queryKey: ["admin-orders"], queryFn: adminApi.orders, refetchInterval: 5000 });
  const retry = useMutation({
    mutationFn: adminApi.retryShopify,
    onSuccess: () => client.invalidateQueries({ queryKey: ["admin-orders"] })
  });

  return (
    <Panel title="Pedidos e Shopify Sync">
      {!query.data?.length ? (
        <EmptyState text="Nenhum pedido local criado." />
      ) : (
        <div className="overflow-auto">
          <table className="w-full min-w-[1040px] text-left text-sm">
            <thead className="text-xs uppercase text-slate-500">
              <tr>
                <th className="py-2">Pedido</th>
                <th>Pagamento</th>
                <th>Shopify</th>
                <th>Order GID</th>
                <th>Erro</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {query.data.map((item) => (
                <tr key={item.publicId} className="border-t border-line align-top">
                  <td className="py-2 font-mono text-xs">{item.publicId}</td>
                  <td>{item.paymentStatus}</td>
                  <td>{item.shopifySyncStatus}</td>
                  <td className="font-mono text-xs">{item.shopifyOrderGid ?? "-"}</td>
                  <td className="max-w-sm text-xs text-red-700">{item.shopifySyncError ?? "-"}</td>
                  <td>
                    <button className="btn" disabled={retry.isPending} onClick={() => retry.mutate(item.publicId)}>
                      <RotateCw size={15} /> Retry
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Panel>
  );
}
